var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.cloudCannonFooterContentLoading)?_c('footer',[_c('main-footer',{attrs:{"links":_vm.links,"desktopImageUrl":_vm.desktopImageUrl,"mobileImageUrl":_vm.mobileImageUrl}}),_c('sub-footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }